#import "~/graphql/fragments/Assets/DefaultImageSrcset.graphql"

fragment DefaultImageAsset on AssetInterface {
    id
    url
    width
    height
    focalPoint
    hasFocalPoint
    ... on media_Asset {
        alt
        title
        credits
        caption
        webp: url @transform(format: "webp", quality: 84)
    }
    ... DefaultImageSrcset
}
